var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "custom-card mb-2" }, [
        _c("h6", { staticClass: "text-muted text-small" }, [
          _vm._v("ВНЕШНИЕ КОНТАКТЫ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-body" },
          [
            _vm.isBusy || (_vm.externalItems && _vm.externalItems.length > 0)
              ? [
                  _c(
                    "div",
                    { staticClass: "page-table-container" },
                    [
                      _c("b-table", {
                        staticClass: "custom-table mb-0",
                        attrs: {
                          id: "location-contacts",
                          busy: _vm.isBusy,
                          items: _vm.externalItems,
                          fields: _vm.fields,
                          "current-page": _vm.externalCurrentPage,
                          "per-page": _vm.perPage,
                          "no-provider-filtering": "",
                          "no-provider-paging": "",
                          "no-provider-sorting": ""
                        },
                        on: {
                          "update:busy": function($event) {
                            _vm.isBusy = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-busy",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-success my-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle"
                                      }),
                                      _vm._v(" "),
                                      _c("strong", [_vm._v("Загрузка")])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "cell(name)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input_name",
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.name,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "name", $$v)
                                      },
                                      expression: "row.item.name"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(job_title)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input_job_title",
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.job_title,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "job_title", $$v)
                                      },
                                      expression: "row.item.job_title"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(phone_number)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-input-group",
                                    { attrs: { size: "sm", prepend: "+7" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input_phone_number",
                                          type: "tel",
                                          size: "sm",
                                          disabled: _vm.isDisabled,
                                          autocomplete: "off",
                                          placeholder: _vm.$t(
                                            "message.customers.modal.phonePlaceholder"
                                          ),
                                          state: _vm.contactPhoneState(
                                            row.item.phone_number
                                          ),
                                          formatter: _vm.phoneNationalNumber,
                                          value: _vm.phoneNationalNumber(
                                            row.item.phone_number
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            row.item.phone_number = $event
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.contactPhoneState(
                                              row.item.phone_number
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  После +7 введите 10 цифр.\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(email)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.email,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "email", $$v)
                                      },
                                      expression: "row.item.email"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(comment)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input_comment",
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.note,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "note", $$v)
                                      },
                                      expression: "row.item.note"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "head(action)",
                              fn: function(row) {
                                return [
                                  _vm.canEditLocations()
                                    ? _c(
                                        "b-btn",
                                        {
                                          staticStyle: {
                                            color: "#1A9167 !important",
                                            "text-decoration": "none !important"
                                          },
                                          attrs: {
                                            variant: "link",
                                            disabled: _vm.isDisabled
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.onAdd(false)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              name: "buttons/plus",
                                              size: 12
                                            }
                                          }),
                                          _vm._v(
                                            "\n                Добавить\n              "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell(action)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "link",
                                        disabled: _vm.isDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemove(row, false)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", {
                                        attrs: {
                                          name: "buttons/trash",
                                          size: 16
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3452833462
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-pagination" },
                    [
                      _c("pagination-footer", {
                        attrs: {
                          "total-rows": _vm.externalItems.length,
                          "per-page": _vm.perPage,
                          "current-page": _vm.externalCurrentPage
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.externalCurrentPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.externalCurrentPage = $event
                          },
                          "per-page-change": function(val) {
                            return _vm.onPerPageChange(
                              val,
                              "externalCurrentPage"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : _c(
                  "div",
                  { staticClass: "empty-state-container" },
                  [
                    _c("v-icon", {
                      attrs: { name: "navbar/empty_table", size: 90 }
                    }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Нет внешних контактов.")]),
                    _vm._v(" "),
                    _c("p", [_vm._v("Добавьте контакты прямо сейчас")]),
                    _vm._v(" "),
                    _vm.canEditLocations()
                      ? _c(
                          "b-btn",
                          {
                            staticClass: "custom-btn-primary mt-1",
                            attrs: { disabled: _vm.isDisabled },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onAdd(false)
                              }
                            }
                          },
                          [
                            _c("v-icon", {
                              staticClass: "mr-1",
                              attrs: { name: "buttons/plus", size: 12 }
                            }),
                            _vm._v("\n          Новый контакт\n        ")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("b-card", { staticClass: "custom-card" }, [
        _c("h6", { staticClass: "text-muted text-small" }, [
          _vm._v("ВНУТРЕННИЕ КОНТАКТЫ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-body" },
          [
            _vm.isBusy || (_vm.internalItems && _vm.internalItems.length > 0)
              ? [
                  _c(
                    "div",
                    { staticClass: "page-table-container" },
                    [
                      _c("b-table", {
                        staticClass: "custom-table mb-0",
                        attrs: {
                          id: "location-contacts",
                          busy: _vm.isBusy,
                          items: _vm.internalItems,
                          fields: _vm.fields,
                          "current-page": _vm.internalCurrentPage,
                          "per-page": _vm.perPage,
                          "no-provider-filtering": "",
                          "no-provider-paging": "",
                          "no-provider-sorting": ""
                        },
                        on: {
                          "update:busy": function($event) {
                            _vm.isBusy = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-busy",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-success my-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle"
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "cell(name)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.name,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "name", $$v)
                                      },
                                      expression: "row.item.name"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(job_title)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.job_title,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "job_title", $$v)
                                      },
                                      expression: "row.item.job_title"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(phone_number)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-input-group",
                                    { attrs: { size: "sm", prepend: "+7" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "tel",
                                          size: "sm",
                                          disabled: _vm.isDisabled,
                                          autocomplete: "off",
                                          placeholder: _vm.$t(
                                            "message.customers.modal.phonePlaceholder"
                                          ),
                                          state: _vm.contactPhoneState(
                                            row.item.phone_number
                                          ),
                                          formatter: _vm.phoneNationalNumber,
                                          value: _vm.phoneNationalNumber(
                                            row.item.phone_number
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            row.item.phone_number = $event
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.contactPhoneState(
                                              row.item.phone_number
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  После +7 введите 10 цифр.\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(email)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.email,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "email", $$v)
                                      },
                                      expression: "row.item.email"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(comment)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    attrs: {
                                      size: "sm",
                                      disabled: _vm.isDisabled,
                                      autocomplete: "off"
                                    },
                                    model: {
                                      value: row.item.note,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "note", $$v)
                                      },
                                      expression: "row.item.note"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "head(action)",
                              fn: function(row) {
                                return [
                                  _vm.canEditLocations()
                                    ? _c(
                                        "b-btn",
                                        {
                                          staticStyle: {
                                            color: "#1A9167 !important",
                                            "text-decoration": "none !important"
                                          },
                                          attrs: {
                                            variant: "link",
                                            disabled: _vm.isDisabled
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.onAdd(true)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              name: "buttons/plus",
                                              size: 12
                                            }
                                          }),
                                          _vm._v(
                                            "\n                Добавить\n              "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell(action)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "link",
                                        disabled: _vm.isDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemove(row, true)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", {
                                        attrs: {
                                          name: "buttons/trash",
                                          size: 16
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3146505588
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-pagination" },
                    [
                      _c("pagination-footer", {
                        attrs: {
                          "total-rows": _vm.internalItems.length,
                          "per-page": _vm.perPage,
                          "current-page": _vm.internalCurrentPage
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.internalCurrentPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.internalCurrentPage = $event
                          },
                          "per-page-change": function(val) {
                            return _vm.onPerPageChange(
                              val,
                              "internalCurrentPage"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : _c(
                  "div",
                  { staticClass: "empty-state-container" },
                  [
                    _c("v-icon", {
                      attrs: { name: "navbar/empty_table", size: 90 }
                    }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Нет внутренних контактов.")]),
                    _vm._v(" "),
                    _c("p", [_vm._v("Добавьте контакты прямо сейчас")]),
                    _vm._v(" "),
                    _vm.canEditLocations()
                      ? _c(
                          "b-btn",
                          {
                            staticClass: "custom-btn-primary mt-1",
                            attrs: { disabled: _vm.isDisabled },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onAdd(true)
                              }
                            }
                          },
                          [
                            _c("v-icon", {
                              staticClass: "mr-1",
                              attrs: { name: "buttons/plus", size: 12 }
                            }),
                            _vm._v("\n          Новый контакт\n        ")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5114cb89", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5114cb89","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationContacts.vue
// module id = null
// module chunks = 